import React, { useEffect, useState } from 'react';
import { TvIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyHeader() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-385">
      {isVisible && <motion.header initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/95 backdrop-blur-sm border-b border-zinc-800" data-id="element-386">
          <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-387">
            <button onClick={scrollToTop} className="flex items-center gap-2 text-white hover:text-emerald-400 transition-colors" data-id="element-388">
              <TvIcon className="w-6 h-6 text-emerald-500" data-id="element-389" />
              <span className="font-bold text-sm sm:text-base" data-id="element-390">
                Guía Magis TV
              </span>
            </button>
            <a href="#checkout-btn" className="bg-emerald-500 hover:bg-emerald-400 text-black font-bold text-sm px-4 py-2 rounded-lg transition-all hover:scale-105" data-id="element-391">
              OBTENER GUÍA
            </a>
          </div>
        </motion.header>}
    </AnimatePresence>;
}